import React from 'react';
import MenuItem from '@mui/material/MenuItem';
import MuiSelect from '@mui/material/Select';

import { dropdownStyles } from 'styles/dropdown';
import selectStyles from './select.style';

const Select = ({
  value = '',
  onChange,
  error,
  loading = false,
  disabled = false,
  styles = {},
  options,
  name,
  ...rest
}) => {
  const handleChange = ({ target: { value: newValue } }) => {
    if (onChange) {
      onChange(typeof newValue === 'string' ? newValue.split(',') : newValue);
    }
  };

  return (
    <MuiSelect
      value={value}
      disabled={disabled || loading}
      onChange={handleChange}
      error={!!error}
      data-testid={`input-${name || 'select'}`}
      sx={{ ...selectStyles.wrapper, ...styles }}
      {...rest}
    >
      {options.map((option) => (
        <MenuItem
          key={option.value}
          value={option.value}
          sx={{
            ...dropdownStyles.listItem,
            margin: '4px 32px 8px 32px',
          }}
        >
          {option.label || option.text}
        </MenuItem>
      ))}
    </MuiSelect>
  );
};

export default Select;
